<template>
  <b-dropdown
    v-if="isEnableI18n"
    class="language-switcher"
    :text="$t('common.language')"
    :title="$t('common.language')"
    variant="light"
    right
    no-caret
    data-testid="languageSwitcher"
  >
    <b-dropdown-item
      v-for="locale in locales"
      :key="locale.code"
      :active="locale.code === $i18n.locale"
      @click="selectLocale(locale.code)"
    >
      {{ locale.label }}
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
import { SUPPORTED_LOCALES, STORAGE_KEY } from '@/i18n';
import useFeatureFlags from '@/composables/useFeatureFlags';
import State from '@/state/State';

const LOCALE_LABELS = {
  'en-GB': 'English',
  'es-ES': 'Español',
};

export default {
  name: 'LanguageSwitcher',
  setup() {
    const { isEnableI18n } = useFeatureFlags();
    return { isEnableI18n };
  },
  computed: {
    locales() {
      return SUPPORTED_LOCALES.map(code => ({ code, label: LOCALE_LABELS[code] || code }));
    },
  },
  methods: {
    selectLocale(code) {
      State.setLocale(code);
      window.localStorage.setItem(STORAGE_KEY, code);
    },
  },
};
</script>
